import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

export const THEME_PRESETS = {
  orange: { name: "Oranye BPBD", primary: "#EA580C", accent: "#0284C7" },
  ocean: { name: "Biru Samudra", primary: "#0284C7", accent: "#EA580C" },
  forest: { name: "Hijau Rimba", primary: "#059669", accent: "#F59E0B" },
  siaga: { name: "Merah Siaga", primary: "#DC2626", accent: "#F59E0B" },
  senja: { name: "Ungu Senja", primary: "#7C3AED", accent: "#EC4899" },
  emas: { name: "Emas Khatulistiwa", primary: "#D97706", accent: "#0EA5E9" },
};

export const FONT_PRESETS = {
  modern: { name: "Modern (Bawaan)", heading: "'Cabinet Grotesk', 'Manrope', sans-serif", body: "'Manrope', sans-serif", gf: null },
  formal: { name: "Formal Resmi", heading: "'Merriweather', serif", body: "'Source Sans 3', sans-serif", gf: "https://fonts.googleapis.com/css2?family=Merriweather:wght@700;900&family=Source+Sans+3:wght@400;600;700&display=swap" },
  dinamis: { name: "Dinamis", heading: "'Bricolage Grotesque', sans-serif", body: "'Figtree', sans-serif", gf: "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:wght@600;700;800&family=Figtree:wght@400;600;700&display=swap" },
  klasik: { name: "Klasik Elegan", heading: "'Playfair Display', serif", body: "'Lato', sans-serif", gf: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=Lato:wght@400;700&display=swap" },
  simpel: { name: "Simpel Bersih", heading: "'Archivo', sans-serif", body: "'Inter', sans-serif", gf: "https://fonts.googleapis.com/css2?family=Archivo:wght@600;700;800&family=Inter:wght@400;600&display=swap" },
};

function ensureFontLoaded(gf) {
  if (!gf) return;
  let link = document.getElementById("dynamic-font");
  if (!link) {
    link = document.createElement("link");
    link.id = "dynamic-font";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  if (link.href !== gf) link.href = gf;
}

export function applyThemeVars(values) {
  const preset = values.theme_preset || "orange";
  let primary, accent;
  if (preset === "custom") {
    primary = values.theme_custom_primary || "#EA580C";
    accent = values.theme_custom_accent || "#0284C7";
  } else {
    const t = THEME_PRESETS[preset] || THEME_PRESETS.orange;
    primary = t.primary;
    accent = t.accent;
  }
  const root = document.documentElement;
  root.style.setProperty("--tp", primary);
  root.style.setProperty("--ta", accent);
  root.style.setProperty(
    "--theme-bg-image",
    preset === "custom" && values.theme_bg_image ? `url("${values.theme_bg_image}")` : "none"
  );
  const font = FONT_PRESETS[values.font_preset || "modern"] || FONT_PRESETS.modern;
  ensureFontLoaded(font.gf);
  root.style.setProperty("--font-heading", font.heading);
  root.style.setProperty("--font-body", font.body);
}

const ContentContext = createContext({ c: (k, f = "") => f, refresh: () => {} });

export function ContentProvider({ children }) {
  const [values, setValues] = useState({});
  const refresh = () => {
    api.get("/content").then((r) => {
      setValues(r.data || {});
      applyThemeVars(r.data || {});
    }).catch(() => {});
  };
  useEffect(() => { refresh(); }, []);
  const c = (key, fallback = "") => values[key] || fallback;
  return <ContentContext.Provider value={{ c, refresh }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
